import React from "react";

import { ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
} from "@mui/material";

import { BackButton } from "@features/ui";

import PreOrderProgramSelector from "./PreOrderProgramSelector";
import PreOrderProgramsSummary from "./PreOrderProgramsSummary";

const PreOrderHeader = () => {
  return (
    <Card>
      <Accordion component={Card} className="!rounded-xl">
        <AccordionSummary
          // Hack to make it render a div instead of a button
          href="#"
          LinkComponent={"div"}
          expandIcon={<ExpandMore />}
          classes={{ content: "min-w-0" }}
        >
          <div className="flex-1 flex justify-between items-center mr-3 gap-3 min-w-0">
            <div className="flex flex-1 gap-2 items-center min-w-0">
              <BackButton defaultUrl="/programs/national" />
              <PreOrderProgramSelector />
            </div>
            <div id="pre-order-header-portal" />
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <PreOrderProgramsSummary />
        </AccordionDetails>
      </Accordion>
    </Card>
  );
};

export default PreOrderHeader;
